import {Link} from 'react-router-dom'
import styled from '../Nav/Nav.module.css';


const Nav = () => {


    return(

        <div className={styled.nav}>
        <Link className={styled.link} to='/quienes-somos'>¿Quienes Somos?</Link>
        <Link to='/tienda-online' className={styled.link}>Tienda</Link>
        <Link className={styled.link} to='/contactanos'>Contactanos</Link>

         </div>

    )


}


export default Nav;